import React, { useState, useEffect, useRef } from "react";
import { Spring, config } from "react-spring/renderprops";
import Konva from "konva";
import { Arc, Stage, Layer } from "react-konva";

export default function ResizeableStageLine(props) {

  
    const container = useRef();
    const [width, setWidth] = useState(props.pdfDim ? parseInt(props.pdfDim.split("x")[0]) || 0 : 0,);
    const [height, setHeight] = useState(props.pdfDim ? parseInt(props.pdfDim.split("x")[1]) || 0 : 0,);  

    useEffect(() => {
      if (props.pdfDim) {
        // For PDF rendering, charts have a specific height and width preset
        setTimeout(() => setWidth(width + 1), setHeight(height + 1), 1000);
      } else {
        // For normal viewing (non-PDF) make sure chart renders within the boundary of it's container
        setTimeout(() => setWidth(container.current.offsetWidth), setHeight(container.current.offsetHeight), 1000);
        // Charts must resize responsively if the container is resized
        if (container.current != null) {
          new ResizeObserver(() => {
            setWidth(container.current.offsetWidth) ;
            setHeight(container.current.offsetHeight);
          }).observe(container.current)
        }
      }
    }, [])

    let height1 = props.pdfDim ? height :width > props.maxHeight ? props.maxHeight : width;

  return (
      <div className="resize-stage" ref={container}>
        <Stage width={width} height={height1}>
          <Layer>{props.render(width, height1)}</Layer>
        </Stage>
      </div>
  )
}